import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.data_source_gps_logger_form', () => {
  void import('./internal/data_source_gps_logger_form')
    .then(({ default: Component }) => Component());
});
